<template>
<div id="addBusinessType">
  <el-dialog width="1200px" v-loading='loading' :visible='visible' :close-on-click-modal='false'
    :close-on-press-escape='false' :show-close='false' @close='close'>
    <template #title>
      <div class="addBusiness_title">{{ title }}业务类型</div>
    </template>
    <el-form :model="businessForm" ref='add_businessForm' label-width="120px" :rules="rules" :inline="true" style="margin-left:30px;">
      <el-form-item label="业务类型名称：" prop="name">
        <el-input v-model="businessForm.name" placeholder="请输入业务类型名称" maxlength="20" style="width: 280px;" size="small"></el-input>
      </el-form-item>
       <el-form-item label="凭证日期：" prop="voucherDateRule">
          <el-select v-model="businessForm.voucherDateRule" placeholder="请选择" style="width: 280px;" size="small">
            <el-option label="交易日期" :value="1"></el-option>
            <el-option label="当期末" :value="0"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="收支方向：" prop="type">
        <el-radio-group v-model="businessForm.type" @change="typeChange" :disabled = "(rowData && rowData.id)?true:false">
          <el-radio label="1">收入</el-radio>
          <el-radio label="0">支出</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <public-table :table="tableData">
      <template slot='operation' slot-scope='props'>
            <div class='hiddenRow'>
              <span @click='handleOperationTable("+", props.scope.row)'>
                <i class="el-icon-plus" title="新增一条" style="margin-right: 15px;"></i>

              </span>
              <span @click='handleOperationTable("-", props.scope.row)'>
                <i class="el-icon-delete" title="删除当前" style="margin-right: 15px;"></i>
              </span>
            </div>
          </template>
      <template slot='summary' slot-scope='props'>
        <el-dropdown trigger="click" :hide-on-click='false'>
          <span class="el-dropdown-link" style='cursor: pointer;'>
            {{ props.scope.row.summaryText && props.scope.row.summaryText != "_" ? props.scope.row.summaryText : "请设置摘要"
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" style='width: 215px;'>
            <el-dropdown-item style='font-weight: 600;'>固定文本</el-dropdown-item>
            <el-dropdown-item>
              <el-checkbox v-model='props.scope.row.haveSummary' @change='handleInputBlur(props.scope.row)'><el-input
                  size='small' style='width: calc(100% - 24px);' placeholder='请输入摘要' v-model='props.scope.row.summary'
                  @blur='handleInputBlur(props.scope.row)'></el-input></el-checkbox>

            </el-dropdown-item>
            <el-dropdown-item style='font-weight: 600;margin-top: 20px;margin-bottom: 10px;'>流水信息</el-dropdown-item>
            <el-dropdown-item>
              <el-checkbox-group v-model="props.scope.row.checkList"
                @change='handleChangeCheckbox($event, props.scope.row, flowingList)'>
                <el-checkbox v-for='i in flowingList' :key='i.value' :label='i.value' style='display: block;'>{{ i.label
                }}</el-checkbox>
              </el-checkbox-group>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template slot='subjectName' slot-scope='props'>
        <el-select v-model="props.scope.row.subjectName" placeholder="请选择" size='mini' filterable v-show="!props.scope.row.disabled">
          <el-option v-for="item in subjectList" :key="item.id" :label="`${item.code} ${item.name}`" :value="item.name">
            {{item.code}} {{item.name}}
          </el-option>
        </el-select>
        <el-input v-show = "props.scope.row.disabled" value = "当前银行账户" size='mini' disabled style="width: 193px;"></el-input>
      </template>
      <template slot='invoiceSubjectRule' slot-scope='props'>
        <el-select v-model="props.scope.row.invoiceSubjectRule" placeholder="请选择" size='mini' :disabled = "props.scope.row.disabled">
          <el-option v-for="item in invoiceSubjectRuleList" :key="item.value" :label="item.label"
            :disabled="item.disabled" :value="item.value">
          </el-option>
        </el-select>
      </template>
      <template slot='moneyRule' slot-scope="props">
        <el-input v-model="props.scope.row.moneyRule" size="mini"></el-input>
      </template>
      <template slot='creditDirection' slot-scope='props'>
        <el-select v-model="props.scope.row.creditDirection" placeholder="请选择" size='mini' :disabled = "props.scope.row.disabled">
          <el-option v-for="item in creditDirectionList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </template>
    </public-table>
    <template #footer>
      <div style="text-align:center">
        <el-button @click="close" size="small" style="width:100px;">取消</el-button>
        <el-button @click="validInfo" size="small" style="width:100px;background:#269D7B;color:#fff">确定</el-button>
      </div>
    </template>
  </el-dialog>
  </div>
</template>

<script>
import { saveBankBusinessType, findBankBusinessRole, getBankBusinessTypeDetail } from '@/api'
import publicTable from '@/components/publicTable'
export default {
  computed: {
    // 科目
    subjectList() {
      return this.$store.state.getSubjectId.AllSubjectList
    },
  },
  watch: {
  },
  components: { publicTable },
  data() {
    return {
      rowData: {},
      title: '',
      cid: '',
      businessForm: {
        name: '',
        type: '1',
        list: [],
        voucherDateRule:0,
      },
      rules: {
        voucherDateRule:[{ required: true, message: '请选择凭证日期类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入业务类型名称', trigger: 'blur' }],
      },
      loading: false,
      visible: false,
      // new
      flowingList: [],//流水信息列表
      invoiceSubjectRuleList: [], // 科目规则
      creditDirectionList: ["借","贷"], // 借贷列表
      tableData: {
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,				// 是否显示加载动画
        hasSelect: false,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        config: [
          {
          label: '',
          value: 'operation',
          show: 'template',
          width: 10
          ,
        },
          {
          label: '摘要',
          value: 'summary',
          show: 'template'
        }, {
          label: '会计科目',
          value: 'subjectName',
          show: 'template'
        }, {
          label: '余额方向',
          value: 'creditDirection',
          show: 'template'
        }, 
        {
          label:'取值（按金额%）',
          value:'moneyRule',
          show:'template'
        },
        {
          label: '科目规则',
          value: 'invoiceSubjectRule',
          show: 'template'
        }],
        data: [
          {
            summary: "",
            summaryText: "",
            subjectName: "当前银行账户",
            creditDirection: "借",
            invoiceSubjectRule: 1,
            haveSummary: false,
            disabled: true,
            checkList: [],
            moneyRule:'',
            superMark: "1",
          },
          {
            summary: "",
            disabled: false,
            subjectName: "",
            summaryText: "",
            creditDirection: "",
            invoiceSubjectRule: "",
            haveSummary: false,
            checkList: [],
            moneyRule:'',
            superMark: "0",
          }
        ],
        page: {
          pageNo: 1,
          pageSize: 10,
          count: 10
        },
        center: {
          textAlign: 'center',
          padding: '6px 0'
        },
        renderHeader: this.renderHeader,
        cellStyle: this.cellStyle,		// 自定义表格样式
        headerCellStyle: this.headerCellStyle,		// 自定义表头样式
      },
    }
  },

  methods: {
        // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "cellStyle"
      }
    },
     // 表头单元格样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "headerCellStyles"
      }
    },
    // 新增删除表格
    handleOperationTable(type, row) {
      if (type === "+") {
        let data =  {
            summary: "",
            disabled: false,
            subjectName: "",
            summaryText: "",
            creditDirection: "",
            invoiceSubjectRule: "",
            moneyRule:'',
            haveSummary: false,
            checkList: [],
            superMark: "0",
          }
           this.tableData.data.push(data);
        // if (row.index === this.tableData.data.length - 1) {
        //   this.tableData.data.push(data);
        // } else {
        //   this.tableData.data.splice(row.index, 0, data)

        // }

      } else {
        if (this.tableData.data.length === 2) {
          return this.$message.warning('表格必须保留两条数据!')
        }
        this.tableData.data.splice(row.index, 1);
      }
      this.tableData.data.map((i, index) => {
        i.index = index;
        return i;
      })
    },
    // 失去焦点
    handleInputBlur(row) {
      let data = row.summaryText ? row.summaryText.split('_') : [];
      if(row.haveSummary) {
        // 如果勾选了checkbox， 则替换值
        data.splice(0,1,row.summary)
      }else {
        data[0] = ""
      }
      row.summaryText = data.join("_");
    },
    // 获取业务类型规则
    async getBankBusinessRole() {
      const { data } = await findBankBusinessRole()
      if (data.data) {
        this.flowingList = data.data.summary || [];
        this.invoiceSubjectRuleList = data.data.subject || [];
      }

    },
    handleChangeCheckbox(e, row, list) {
      let data = "";
      list.forEach(i => {
        e.forEach(j => {
          if (i.value === j) {
            data = data ? data + "_" + i.label : i.label;
          }
        })
      })
      if (row.summary && row.haveSummary) {
        row.summaryText = data ? row.summary + "_" + data : row.summary;
      } else {
        row.summaryText = "" + "_" + data;
      }
    },
    /// up new
    typeChange(val) {
      if (val == 1) {
        this.businessForm.debit = '当前银行账户'
        this.businessForm.creditor = ''
      } else if (val == 0) {
        this.businessForm.creditor = '当前银行账户'
        this.businessForm.debit = ''
      }

      this.tableData.data.forEach(i=> {
        i.disabled = false
        if(val == i.superMark) {
          i.disabled = true
          i.creditDirection = val==1?"借":"贷"
          i.invoiceSubjectRule =  1
          i.subjectName = "当前银行账户"
        }
      })
      this.$nextTick(() => {
        this.$refs.add_businessForm.clearValidate()
      })

    },
    // 查询所有科目
    getSubject() {
      this.$store.dispatch("getAllSubject");
    },
    close() {
      this.$refs.add_businessForm.clearValidate()
      this.businessForm = {
        voucherDateRule:0,
        name: '',
        type: '1',
        list: []
      }
      this.tableData.data =  [
          {
            summary: "",
            summaryText: "",
            subjectName: "当前银行账户",
            creditDirection: "借",
            invoiceSubjectRule: 1,
            haveSummary: false,
            disabled: true,
            moneyRule:'',
            checkList: [],
            superMark: "1",
          },
          {
            summary: "",
            disabled: false,
            subjectName: "",
            summaryText: "",
            moneyRule:'',
            creditDirection: "",
            invoiceSubjectRule: "",
            haveSummary: false,
            checkList: [],
            superMark: "0",
          }
        ]
      this.cid = ''
      this.visible = false
    },
    // 获取业务类型详情
    async getDetail(id) {
      const { data } = await getBankBusinessTypeDetail({ id })
      const info = data.data;
      if(info) {
        this.businessForm.name = info.name
        this.businessForm.type = String(info.type)
        this.businessForm.voucherDateRule = info.voucherDateRule
        this.typeChange(this.businessForm.type)
        let list = info.list.map((i,index)=> {
          return {
            ...this.tableData.data[index],
            ...i,
            checkList: i.invoiceInfo?i.invoiceInfo.split(",").map(i=> Number(i)):[],
            haveSummary: i.summary?true:false
          }
        })
        this.tableData.data = list;
      }
    },
    handleOpen(title, row) {
      this.getSubject()
      this.getBankBusinessRole()
      this.rowData = row || {}
      const { id } = { ...row }
      this.businessForm.type = row.type
      if(this.businessForm.type==0){
       this.typeChange(this.businessForm.type)
       console.log(this.tableData.data)
       this.tableData.data = this.tableData.data.map(e=>{
          if(e.superMark==1){
            e.subjectName =''
            e.creditDirection = ''
            e.invoiceSubjectRule =''
            
          }
          return e
       })
      }
      this.title = title
      this.visible = true
      // 获取详情渲染
      if(id) {
        this.getDetail(id);
      }
    },
    validInfo() {
      console.log(this.businessForm)
      const reg = /^-?[1-9]\d*(\.\d{1,2})?|[1-9]\d*$/;
      this.$refs.add_businessForm.validate(valid => {
        if (valid) {
          // 验证表格必填
          let isOk = true;
          const datalist = this.tableData.data;
          for(let i = 0; i < datalist.length; i++) {
            if(!datalist[i].summaryText || !datalist[i].subjectName || !datalist[i].creditDirection || !datalist[i].invoiceSubjectRule||!datalist[i].moneyRule) {
              isOk = false;
              this.$message.error("摘要、会计科目、余额方向、取值、科目规则不能为空")
              break;
            }
            if(['',null,undefined].indexOf(datalist[i].moneyRule)<0){
                if(!reg.test(datalist[i].moneyRule)){
                  this.$message.error('取值不能为0，保留两位小数')
                  isOk = false
                  break;
                }
            }
            console.log(datalist[i].moneyRule)
          }
          if(!isOk) return;
          this.businessForm.list = datalist.map(i=> {
            return {
              ...i,
              invoiceInfo: i.checkList.toString()
            }
          })
          this.businessForm.id = this.rowData.id || "";
          this.loading = true
          saveBankBusinessType(this.businessForm).then(res => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg)
              this.$emit('saveSuccess')
              this.visible = false
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    closeDialog() {
    },
  },
}
</script>
<style lang='less'>
#addBusinessType {
.cellStyle {
      border-bottom: none;
      background: #fff;
}
.headerCellStyles {
      background-color: #fff;
      border-color: #fff !important;
}
.el-dialog__body {
      padding: 0px 30px 50px 0px;
 }
 .el-table__row {
      .hiddenRow {
        display: none;
        line-height: 10px;

        span {
          display: block;
          cursor: pointer;
        }
      }

      &:hover {
        .hiddenRow {
          display: block;
        }
      }

      ;
 }
    .el-table--border {
      border: none;
    }

    .el-table::before {
      height: 0;
    }
}

</style>
<style lang='less' scoped>

.addBusiness_title {
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addBusinessType.vue